import * as React from 'react';
import Vditor from 'vditor';

interface IProps {
  readonly value: string;
  readonly isPreview: boolean;
  readonly placeholder?: string;
  readonly className?: string;
  readonly renderPreviewDone?: (
    height: number,
    divContainer: HTMLDivElement
  ) => void;
}

interface IState {
  readonly value: string;
}

// markdown编辑器
export class VditorMarkdown extends React.Component<IProps, IState> {
  private vditor: null | Vditor = null;
  private divContainer: HTMLDivElement | null = null;
  public constructor(props: IProps) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  public async componentDidMount() {
    if (this.props.isPreview) {
      if (this.props.value) {
        this.setMode(this.props.value, this.props.isPreview);
      }
      return;
    }
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.value !== this.props.value) {
      // 预览模式
      if (nextProps.isPreview) {
        this.setMode(nextProps.value, true);
      }
    }
  }

  public shouldComponentUpdate(nextProps: Readonly<IProps>) {
    return (
      this.props.value !== nextProps.value ||
      this.props.placeholder !== nextProps.placeholder ||
      this.props.className !== nextProps.className ||
      this.props.isPreview !== nextProps.isPreview
    );
  }

  public componentWillUnmount() {
    try {
      if (this.vditor) {
        this.vditor.destroy();
      }
    } catch (err) {}
  }

  public render() {
    return (
      <div
        className={`markdown-vditor ${this.props.className || ''}`}
        ref={this.onDivContainerRef}
      ></div>
    );
  }

  private onDivContainerRef = (el: HTMLDivElement | null) => {
    this.divContainer = el;
  };

  private setMode = (value: string, isPreview: boolean | undefined) => {
    if (isPreview === true) {
      this.initPreviewMode(value);
      return;
    }
  };

  // 初始化纯渲染模式
  private initPreviewMode = (value: string) => {
    try {
      if (this.divContainer) {
        Vditor.preview(this.divContainer, value, {
          mode: 'light',
          speech: {
            enable: true,
          },
          anchor: 1,
        });
        setTimeout(() => {
          if (this.props.renderPreviewDone && this.divContainer) {
            this.props.renderPreviewDone(
              this.divContainer.offsetHeight,
              this.divContainer
            );
          }
        }, 100);
      }
    } catch (err) {
      console.error('showPreviewMode', err);
    }
  };
}
